import React from "react";
import InsuranceContainer from "../../container/admin/insurance";

const InsuranceView = () => {
    return <InsuranceContainer />;
};

export default InsuranceView;
